import React, { useState } from "react";
import { applyMillingFiles } from "./millingBatch";

export default function MillingBatchPicker({ value, onChange, disabled }) {
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  return <div className="border rounded p-2 mb-3">
    <label>Standard és változatok feltöltése együtt
      <input className="form-control" type="file" multiple accept=".dxf,.png,.jpg,.jpeg" disabled={disabled}
        onChange={event => {
          const files = Array.from(event.target.files || []);
          event.target.value = "";
          if (!files.length) return;
          setError(""); setMessage("");
          try {
            onChange(applyMillingFiles(value, files));
            setMessage(`${files.length} fájl hozzárendelve. Ellenőrizd a fő mintát és a változatokat, majd mentsd el.`);
          } catch (e) { setError(e.message); }
        }} />
    </label>
    <p className="small text-muted mb-0">Egy marás képeit és DXF-jeit egyszerre is kijelölheted. Például: A430I-Standard.png,
      A430I-Standard.dxf, A430I-Ráma.png. A Standard a fő minta, az azonos nevű képek és DXF-ek egy változathoz kerülnek.
      Fiókelő: magasság &lt; 150 mm; Joly: szélesség &lt; 150 mm; Ráma és egyéb változat: kézi választás.
      A meglévő változat azonos típusú fájlja lecserélődik, beállításai megmaradnak.</p>
    {error && <p role="alert" className="text-danger mb-0">{error}</p>}
    {message && <p role="status" className="text-success mb-0">{message}</p>}
  </div>;
}
